import axiosInstance from "../Interceptors/axiosInstance.jsx";
import Cookies from "js-cookie";

const headers = {
  accept: "*/*",
  "Content-Type": "application/json",
};

export const login = async ({ userName, password, keepLogged }) => {
  return await axiosInstance.post(
    "auth/login",
    {
      userName,
      password,
      keepLogged,
    },
    { headers }
  );
};

const getSessionCookieOptions = (keepLogged) => {
  if (keepLogged) {
    return { expires: 7 };
  }
  return {};
};

const getRefreshCookieOptions = (keepLogged) => {
  if (keepLogged) {
    return { expires: 30 };
  }
  return {};
};

export const storeAuthCookies = (result, keepLogged) => {
  const sessionOptions = getSessionCookieOptions(keepLogged);
  const refreshOptions = getRefreshCookieOptions(keepLogged);

  Cookies.set("accessToken", result.accessToken, sessionOptions);
  Cookies.set("refreshToken", result.refreshToken, refreshOptions);
  Cookies.set("role", result.role, sessionOptions);
  Cookies.set("userName", result.userName, sessionOptions);
};

export const clearAuthCookies = () => {
  Cookies.remove("accessToken");
  Cookies.remove("refreshToken");
  Cookies.remove("role");
  Cookies.remove("userName");
};
